import React from "react";
import "./PullToRefreshIndicator.css";

export default function PullToRefreshIndicator({
  pullDistance = 0,
  visible = false,
  isReady = false,
  isRefreshing = false,
}) {
  const translateY = Math.max(-72, pullDistance - 72);

  let label = "Tira per aggiornare";
  if (isRefreshing) label = "Aggiornamento...";
  else if (isReady) label = "Rilascia per aggiornare";

  return (
    <div
      className={`ptr-wrap ${visible ? "is-visible" : ""} ${
        isRefreshing ? "is-refreshing" : ""
      }`}
      style={{ transform: `translateY(${translateY}px)` }}
      aria-hidden={!visible}
    >
      <div className="ptr-pill">
        <div className={`ptr-spinner ${isReady ? "is-ready" : ""}`} />
        <span className="ptr-label">{label}</span>
      </div>
    </div>
  );
}
